import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import EstimateForm from './subroutes/form'
import Results from './subroutes/results'
import EnsureSession from 'components/EnsureSession'

const RouteEstimate = ({ location }) => (
  <EnsureSession>
    <Switch>
      <Route path='/form' component={EstimateForm} />
      <Route path='/results' component={Results} />
      <Route path='/'><Redirect to={`/form${location.search}`} /></Route>
    </Switch>
  </EnsureSession>
)

export default RouteEstimate



// WEBPACK FOOTER //
// ./src/routes/estimate/index.js